import { useState, useEffect } from "react";
import { Droppable, Draggable } from "@hello-pangea/dnd";
import Field from "../Field/Field";
import FieldClone from "../Field/FieldClone";
import "./Column.scss";
import PlusSign from "../../PlusSign/PlusSign";
import BlockDialog from "../../Dialogs/BlockDialog";
import Button from "../../../../buttons/Button";
import { buildUrl } from "../../../../utils/helper";

export default function Column({
  uiBlocks,
  buildArea,
  setBuildArea,
  setUiBlocks,
  rowIndex,
  columnIndex,
  column,
  setIsOpenedDialog,
  deleteCol,
  deleteField,
}) {
  const [isOpen, setOpen] = useState(false);
  const [isOpenedFieldDialog, setIsOpenedFieldDialog] = useState(false);
  const [isLarge, setIsLarge] = useState(false);

  useEffect(() => {
    setIsOpenedDialog(isOpen);
  }, [isOpen, setIsOpenedDialog]);

  useEffect(() => {
    const hasLarge = column.data.some(f => f.customWidth === 'detail-large');
    setIsLarge(hasLarge);
  }, [column]);

  return (
    <>
      {isOpen && (
        <BlockDialog
          setOpen={setOpen}
          isOpen={isOpen}
          uiBlocks={uiBlocks}
          setBuildArea={setBuildArea}
          buildArea={buildArea}
          setUiBlocks={setUiBlocks}
          rowIndex={rowIndex}
          columnIndex={columnIndex}
          fieldToMake={0} // 0 - FIELD
        />
      )}

      <Draggable
        key={`column-${rowIndex}-${columnIndex}-grab`}
        draggableId={`column-${rowIndex}-${columnIndex}-grab`}
        index={columnIndex}
        type="column"
        isDragDisabled={isOpenedFieldDialog}
      >
        {provided => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            className={`column ${isLarge ? 'large-column' : ''}`}
          >
            <div className="colTitle">
              <span>Stĺpec</span>
              <Button
                onClick={() => deleteCol(rowIndex, columnIndex)}
                imageUrl={buildUrl('assets/icons/close.svg')}
                title="Vymazať stĺpec"
                className="col-delete"
              />
            </div>

            <Droppable
              key={`column-${rowIndex}-${columnIndex}`}
              droppableId={`column-${rowIndex}-${columnIndex}`}
              direction="vertical"
              type="field"
              renderClone={(prov, snapshot, rubric) => {
                const idx = rubric.source.index;
                const fld = column.data[idx];
                return (
                  <div
                    ref={prov.innerRef}
                    {...prov.draggableProps}
                    {...prov.dragHandleProps}
                    className="dnd-clone-pos"
                    style={{ ...prov.draggableProps.style }}
                  >
                    <FieldClone field={fld} />
                  </div>
                );
              }}
            >
              {(providedCol, snapshot) => (
                <div
                  ref={providedCol.innerRef}
                  className={`column-droppable ${snapshot.isDraggingOver ? 'dragging-over' : ''}`}
                  {...providedCol.droppableProps}
                >
                  {column.data.map((fld, idx) => (
                    <Field
                      key={idx}
                      deleteField={deleteField}
                      setIsOpenedFieldDialog={setIsOpenedFieldDialog}
                      setIsOpenedDialog={setIsOpenedDialog}
                      buildArea={buildArea}
                      setBuildArea={setBuildArea}
                      rowIndex={rowIndex}
                      columnIndex={columnIndex}
                      fieldIndex={idx}
                      field={fld}
                    />
                  ))}
                  {providedCol.placeholder}
                </div>
              )}
            </Droppable>

            <div onClick={() => setOpen(true)} className="plusSignWrapper">
              <PlusSign />
            </div>
          </div>
        )}
      </Draggable>
    </>
  );
}

